import { render, staticRenderFns } from "./CampaignSettingsName.vue?vue&type=template&id=419ff452&"
import script from "./CampaignSettingsName.vue?vue&type=script&lang=js&"
export * from "./CampaignSettingsName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports